import { createSlice } from '@reduxjs/toolkit';
import { IReliability } from '../../types/reliability';

const initialState = {
  reliability: null as IReliability | null,
};

export const reliabilitySlice = createSlice({
  name: 'reliabilityState',
  initialState,
  reducers: {},
});

export const { reducer: reliabilityReducer } = reliabilitySlice;
